import { v4 as uuidv4 } from 'uuid';

import { MatchType } from '@frontend/types/workflow-agent';

/**
 * Generate a unique UUID for nodes
 */
export function generateNodeId(): string {
  return uuidv4();
}

/**
 * Generate a unique UUID for edges
 */
export function generateEdgeId(): string {
  return uuidv4();
}

/**
 * Simple string hash function for deterministic IDs
 */
function simpleHash(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash).toString(36).substring(0, 12);
}

/**
 * Generate a deterministic condition node ID based on parent step ID and condition content
 */
export function generateConditionNodeId(
  parentStepId: string,
  condition: { matching_condition: string; match_type: MatchType }
): string {
  const contentString = `${condition.match_type}:${condition.matching_condition}`;
  const hash = simpleHash(contentString);
  return `${parentStepId}-condition-${hash}`;
}
